<template>
  <div class="demo-spin-container">
    <MaxTable ref="MaxTable"></MaxTable>
    <Row>
      <ButtonGroup>
        <Button :type="showQuery ? 'warning': 'primary'" icon="ios-funnel-outline" @click="showQueryClick">{{ showQuery ? '关闭筛选': '筛选' }}</Button>
        <Button :type="showOrdering ? 'warning': 'primary'" @click="showOrderingClick">
          <font-awesome-icon icon="sort-amount-down" />
          <span style="margin-left: 4px">{{ showOrdering ? '关闭排序': '排序' }}</span>
        </Button>
      </ButtonGroup>
      <Button icon="ios-expand" @click="fullTable">全屏</Button>
        <!-- <Poptip
          style="margin-left: 10px"
          confirm
          title="请确认是否导出?"
          @on-ok="exportData"
          ok-text="确认"
          cancel-text="取消"
          placement="bottom">
          <Button icon="ios-download-outline" type="primary">导出结果</Button>
        </Poptip> -->

        <Poptip
        ref="exportDbDataPoptip"
        title="请确认是否导出?"
        placement="bottom">
        <Button icon="ios-download-outline" type="warning">导出结果</Button>
        <div slot="content" style="padding: 10px; width:300px">
          <ButtonGroup>
            <Button type="primary" @click="exportData('csv')">Csv</Button>
            <Button type="default" @click="exportData('excel')">Excel</Button>
            <Button type="primary" @click="exportInsert()">Insert</Button>
            <Button type="warning" @click="exportClose">取消</Button>
          </ButtonGroup>
        </div>
      </Poptip>

        <Button type="primary" icon="ios-refresh" @click="getSQLData()" style="margin-left: 10px">刷新</Button>
      <!-- <Dropdown style="margin-left: 20px" @on-click="moreTools" transfer v-if="callbackdata.table">
        <Button type="default">
          更多操作
          <Icon type="ios-arrow-down"></Icon>
        </Button> -->
        <!-- <DropdownMenu slot="list">
          <DropdownItem style="color: red" name="truncate" :disabled="truncating">清空表</DropdownItem>
        </DropdownMenu> -->
      <!-- </Dropdown> -->
      <!-- <div style="float: right"> -->
      <!-- </div> -->
      <div style="margin-top: 10px">
        <div v-show="showQuery" style="margin-top: 10px">
          <Divider orientation="left" dashed>筛选</Divider>
          <div v-for="(queryItem, queryIndex) in query" :key="'queryIndex_' + queryIndex" style="margin-bottom: 5px">
            <Select style="width: 150px; float: left;" placeholder="筛选字段" v-model="queryItem.field" size="small">
              <Option v-for="C in columnsNames" :value="C" :key="C">{{ C }}</Option>
            </Select>
            <Select style="width: 100px; margin-left: 5px; float: left;" placeholder="符号" v-model="queryItem.symbol" size="small">
              <Option v-for="symbol in querySymbolList" :value="symbol.value" :key="symbol.value">{{ symbol.label }}</Option>
            </Select>
            <Input v-model="queryItem.value" size="small" style="width: 200px; margin-left: 5px; float: left;"
                   v-if="queryItem.symbol !== 'IS NULL' && queryItem.symbol !== 'IS NOT NULL'">
              <span slot="prepend" v-if="queryItem.symbol === 'LIKE'">%</span>
              <span slot="prepend" v-else-if="queryItem.symbol === 'IN' || queryItem.symbol === 'NOT IN'">(</span>
              <span slot="prepend" v-else></span>
              <span slot="append" v-if="queryItem.symbol === 'LIKE'">%</span>
              <span slot="append" v-else-if="queryItem.symbol === 'IN' || queryItem.symbol === 'NOT IN'">)</span>
              <span slot="append" v-else></span>
            </Input>
            <Select style="width: 100px; margin-left: 5px; float: left;" placeholder="连接符" v-model="queryItem.link" size="small"
                    v-if="queryIndex !== query.length - 1">
              <Option v-for="link in linkList" :value="link" :key="link">{{ link }}</Option>
            </Select>
            <!--<Input size="small" v-model="queryItem.value" style="width: 200px; margin-left: 5px" />-->
            <Tooltip content="移除字段" style="line-height: 22px">
              <a v-on:click="removeQueryField(queryIndex)" style="color: #515a6e; margin-left: 10px"><Icon type="md-close" size=15 /></a>
            </Tooltip>
          </div>
          <Row style="margin-top: 10px">
            <a v-on:click="addQueryField()">添加字段</a>
            <a style="margin-left: 30px" v-on:click="getSQLData()">应用</a>
          </Row>
          <!--<Input placeholder="如 id > 5 AND name like '%admin%'" v-model="query" @on-enter="getSQLData()" @on-search="getSQLData()" search enter-button="应用"/>-->
        </div>
        <div v-show="showOrdering" style="margin-top: 20px">
          <Divider orientation="left" dashed>排序</Divider>
          <div v-for="(orderingItem, orderingIndex) in ordering" :key="'orderingIndex_' + orderingIndex" style="margin-bottom: 5px">
            <Select style="width: 150px" placeholder="排序字段" v-model="orderingItem.field" size="small">
              <Option v-for="orderingC in columnsNames" :value="orderingC" :key="orderingC">{{ orderingC }}</Option>
            </Select>
            <span style="margin: 0 10px 0 0">：</span>
            <RadioGroup v-model="orderingItem.order">
              <Radio label="ASC">升序</Radio>
              <Radio label="DESC">降序</Radio>
            </RadioGroup>
            <Tooltip content="移除字段">
              <a v-on:click="removeOrderField(orderingIndex)" style="color: #515a6e; margin-left: 10px"><Icon type="md-close" size=15 /></a>
            </Tooltip>
          </div>
          <Row style="margin-top: 10px">
            <a v-on:click="addOrderingField()">添加字段</a>
            <a style="margin-left: 30px" v-on:click="getSQLData()">应用</a>
          </Row>
        </div>
      </div>
      <Divider dashed ></Divider>
    </Row>
    <Alert show-icon v-show="msg">{{ msg }}</Alert>
    <Table ref="table" :data="data" :columns="columns" :height="data.length > 12 ? 600 : 0" />
    <div style="margin: 10px 0; overflow: hidden;">
      <div style="float: right;">
        <Button icon="ios-arrow-back" :disabled="page === 1" @click="getSQLData(page - 1)"></Button>
        <Input style="margin-left: 7px; width: 45px;" v-model="page" @on-enter="getSQLData(page)" number />
        <Button icon="ios-arrow-forward" style="margin-left: 7px" @click="getSQLData(page + 1)"></Button>
      </div>
    </div>
    <Spin size="large" fix v-if="getting"></Spin>
    <Row style="margin-top: 30px">
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Row>
  </div>
</template>

<script>
import { executeSQL, createExecuteLog } from '@/api/workflow/mysql'
import MaxTable from '@/view/components/modal/max-table'
import SQLResults from './sqlResults'
import excel from '@/libs/excel'
export default {
  name: 'dbTableData',
  components: {
    MaxTable,
    SQLResults
  },
  data () {
    return {
      data: [],
      columns: [],
      columnsNames: [],
      getting: false,
      query: [],
      showQuery: false,
      querySymbolList: [
        {
          value: '=',
          label: '等于'
        },
        {
          value: '!=',
          label: '不等于'
        },
        {
          value: '<',
          label: '小于'
        },
        {
          value: '<=',
          label: '小于等于'
        },
        {
          value: '>',
          label: '大于'
        },
        {
          value: '>=',
          label: '大于等于'
        },
        {
          value: 'LIKE',
          label: '包含'
        },
        {
          value: 'IS NULL',
          label: '为空'
        },
        {
          value: 'IS NOT NULL',
          label: '不为空'
        },
        {
          value: 'IN',
          label: '在列表中'
        },
        {
          value: 'NOT IN',
          label: '不在列表中'
        }
      ],
      linkList: ['and', 'or', 'and not', 'or not'],
      ordering: [],
      showOrdering: '',
      count: 0,
      limit: 100,
      page: 1,
      msg: '',
      isInit: false,
      truncating: false,
      sql: ''
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    this.isInit = true
    this.getSQLData()
  },
  methods: {
    // 获取数据
    getSQLData (value = 1) {
      // 判断数字
      if (isNaN(value)) {
        value = 1
      } else if (value <= 0) {
        value = 1
      }
      this.page = value
      let offset = 0
      // 判断页码
      if (this.page > 1) {
        offset = (this.page - 1) * 100
      }
      // 筛选
      let queryQ = ' '
      if (this.query.length) {
        queryQ = ' WHERE '
        let queryList = []
        for (let i in this.query) {
          if (this.query[i].field) {
            let queryStr = this.query[i].field + ' ' + this.query[i].symbol
            let queryValue = this.query[i].value
            if (this.query[i].symbol === 'IN' || this.query[i].symbol === 'NOT IN') {
              queryValue = queryValue.replaceAll('\'', '')
              queryValue = queryValue.replaceAll(' ', '')
              let newValue = ''
              if (queryValue.indexOf(',') !== -1) {
                queryValue.split(',').forEach(_v => {
                  newValue += `'${_v}',`
                })
                newValue = newValue.substring(0, newValue.length - 1)
              } else if (queryValue.indexOf('，') !== -1) {
                queryValue.split('，').forEach(_v => {
                  newValue += `'${_v}',`
                })
                newValue = newValue.substring(0, newValue.length - 1)
              } else {
                newValue = `'${queryValue}'`
              }
              queryValue = '(' + newValue + ')'
            } else if (this.query[i].symbol === 'LIKE') {
              queryValue = '\'%' + queryValue + '%\''
            } else {
              queryValue = `'${queryValue}'`
            }
            if (this.query[i].symbol !== 'IS NULL' && this.query[i].symbol !== 'IS NOT NULL') {
              queryStr += (' ' + `${queryValue}`)
            }
            if (i + '' !== this.query.length - 1 + '') {
              queryStr += (' ' + this.query[i].link + ' ')
            }
            queryList.push(queryStr)
          } else {
            this.$Notice.error({
              title: '请检查筛选字段是否有效！'
            })
            return false
          }
        }
        queryQ += queryList.join('')
      }
      // 排序
      let orderQ = ' '
      if (this.ordering.length) {
        orderQ = ' ORDER BY '
        let orderList = []
        for (let i in this.ordering) {
          if (this.ordering[i].order && this.ordering[i].field) {
            orderList.push(this.ordering[i].field + ' ' + this.ordering[i].order)
          } else {
            this.$Notice.error({
              title: '请检查排序字段是否有效！'
            })
            return false
          }
        }
        orderQ += orderList.join(',')
      }
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: this.callbackdata.sql + queryQ + orderQ + ' LIMIT ' + this.limit + ' OFFSET ' + offset,
        limit: this.limit
      }
      this.sql = data.sql
      let that = this
      that.getting = true
      executeSQL(data).then(res => {
        that.data = []
        that.columns = []
        if (res.data.results.length > 0) {
          this.data = res.data.results[0]['data']
          this.msg = res.data.results[0]['msg']
          this.count = res.data.results[0]['rowcount']
          res.data.results.forEach(function (item, index) {
            let cols = Object.keys(item['data'][0])
            if (cols) {
              cols.forEach(function (row) {
                if (that.isInit) {
                  that.columnsNames.push(row)
                }
                that.columns.push({ 'title': row, 'key': row, 'minWidth': 130 })
              })
            }
          })
        }
        that.isInit = false
        that.getting = false
      }).catch(res => {
        that.getting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 全屏查看表格
    fullTable () {
      this.$refs.MaxTable.showModal(this.data, this.columns, this.callbackdata.label)
    },
    // 显示/关闭筛选
    showQueryClick () {
      if (this.showQuery && this.query.length) {
        this.$Modal.confirm({
          title: '关闭筛选将清空筛选字段，确认关闭吗？',
          onOk: () => {
            this.showQuery = !this.showQuery
            this.query = []
            this.getSQLData()
          },
          onCancel: () => {
            return false
          }
        })
      } else {
        this.showQuery = !this.showQuery
        if (this.showQuery && !this.query.length) {
          this.addQueryField()
        }
      }
    },
    // 添加筛选字段
    addQueryField () {
      this.query.push({
        field: '',
        symbol: '=',
        value: '',
        link: 'and'
      })
    },
    // 移除筛选字段
    removeQueryField (index) {
      this.query.splice(index, 1)
    },
    // 显示/关闭排序
    showOrderingClick () {
      if (this.showOrdering && this.ordering.length) {
        this.$Modal.confirm({
          title: '关闭排序将清空排序字段，确认关闭吗？',
          onOk: () => {
            this.showOrdering = !this.showOrdering
            this.ordering = []
            this.getSQLData()
          },
          onCancel: () => {
            return false
          }
        })
      } else {
        this.showOrdering = !this.showOrdering
        if (this.showOrdering && !this.ordering.length) {
          this.addOrderingField()
        }
      }
    },
    // 添加排序字段
    addOrderingField () {
      this.ordering.push({
        field: '',
        order: 'ASC'
      })
    },
    // 移除排序字段
    removeOrderField (index) {
      this.ordering.splice(index, 1)
    },

    exportClose () {
      this.$refs.exportDbDataPoptip.cancel()
    },

    // 导出
    exportData (type) {
      if (type === 'csv') {
        this.$refs.table.exportCsv({
          filename: `data-${(new Date()).valueOf()}.csv`
        })
      } else {
        const keys = this.columns.map((item) => item.key)
        excel.export_array_to_excel({
          title: keys,
          key: keys,
          data: this.data,
          autoWidth: true,
          filename: `query-${(new Date()).valueOf()}`
        })
      }

      createExecuteLog({
        instance: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: this.sql ? '导出表格记录, 语句如下: ' + this.sql : '导出执行记录',
        is_failed: 0,
        execute_user: this.$store.state.user.userId
      })
    },

    exportInsert () {
      const sql = this.callbackdata.sql
      // 正则表达式匹配表名（可能包含 schema 前缀）
      const regex = /(?:FROM|JOIN|UPDATE|INSERT INTO|DELETE FROM)\s+([`"]?)(\w+)\1?\.([`"]?)(\w+)\3?/i
      const match = sql.match(regex)
      console.log(match)
      let table = null
      if (match !== null) {
        const schema = match[2] // schema 名称
        table = match[4] // 表名
        console.log(schema, table)
        if (table) {
          this.$refs.SQLResults.exportInsert(table)
          return
        }
      }

      // 如果没有 schema 前缀，直接提取表名
      const regexWithoutSchema = /(?:FROM|JOIN|UPDATE|INSERT INTO|DELETE FROM)\s+([`"]?)(\w+)\1?/i
      const matchWithoutSchema = sql.match(regexWithoutSchema)
      console.log(matchWithoutSchema)
      if (matchWithoutSchema) {
        table = matchWithoutSchema[2] // 表名
      }
      console.log(table)
      if (table === null) {
        this.$Message.info('表名不能为空')
      } else {
        this.downloadInsertStatementsAsFile(table, this.data, `${table}-${(new Date()).valueOf()}.sql`)
      }
    },

    generateInsertStatement (tableName, data) {
      if (!Array.isArray(data)) {
        data = [data] // 如果数据不是数组，将其转换为数组
      }
      const statements = data.map(item => {
        const columns = Object.keys(item).map(key => `\`${key}\``).join(', ')
        const values = Object.values(item).map(value => {
          if (value === null || value === undefined) {
            return 'NULL'
          } else if (typeof value === 'string') {
            return `'${value.replace(/'/g, "''")}'` // 处理字符串中的单引号
          } else if (typeof value === 'boolean') {
            return value ? 1 : 0 // 将布尔值转换为 0 或 1
          } else {
            return value // 数字或其他类型直接使用
          }
        }).join(', ')
        return `INSERT INTO \`${tableName}\` (${columns}) VALUES (${values});`
      })
      return statements.join('\n')
    },

    downloadInsertStatementsAsFile (tableName, data, fileName = 'insert_statements.sql') {
      // 生成 INSERT 语句
      const insertStatement = this.generateInsertStatement(tableName, data)
      // 创建 Blob 对象
      const blob = new Blob([insertStatement], { type: 'text/plain' })
      // 创建下载链接
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      // 触发下载
      link.click()
      // 释放 URL 对象
      URL.revokeObjectURL(link.href)
    },

    // 更多操作
    moreTools (type) {
      switch (type) {
        case 'truncate':
          this.truncateTable()
          break
      }
    },
    // 清空表
    truncateTable () {
      if (this.truncating) {
        return false
      }
      this.$Modal.confirm({
        title: '确认清空表「' + this.callbackdata.table + '」吗？',
        onOk: () => {
          this.truncating = true
          let sql = 'TRUNCATE TABLE ' + this.callbackdata.table + ';'
          this.execSQLAction(sql, 'truncate')
        }
      })
    },
    // 执行SQL动作
    execSQLAction (sql, type) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: 100
      }
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          results.push({ 'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg'] })
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({ 'title': row, 'key': row, 'minWidth': 130 })
            })
          }
        })
        this.$refs.SQLResults.showResult(results)
        switch (type) {
          case 'truncate': {
            this.truncating = false
            this.getSQLData()
            break
          }
        }
      }).catch(res => {
        switch (type) {
          case 'truncate': {
            this.truncating = false
            this.getSQLData()
            break
          }
        }
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.demo-spin-container{
    width: 100%;
    height: 100%;
    display: inline-block;
    position: relative;
    border: 1px solid #eee;
}
</style>
